import { BoxContainer } from '@/components';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { PersonalLoansInner } from './PersonalLoansInner/PersonalLoansInner';

import { JSX } from 'react';
import { ProspectData } from '@/types/salesforce';
import styles from './styles.module.scss';

export type PersonalLoansProps = SliceComponentProps<
  Content.PersonalLoansSlice,
  ProspectData
>;

const PersonalLoans = ({ slice, context }: PersonalLoansProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
    >
      <BoxContainer styles={styles.box}>
        <PersonalLoansInner
          data={slice.primary}
          prospect={context}
          variant={slice.variation}
        />
      </BoxContainer>
    </section>
  );
};

export default PersonalLoans;
